import {
  Autocomplete as MuiAutocomplete,
  InputAdornment,
  TextField,
} from "@mui/material";
import type { ReactNode } from "react";

export type AutocompleteProps<Option> = {
  options: Option[];
  value: Option | null;
  onChange: (value: Option | null) => void;
  placeholder?: string;
  fullWidth?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
};

export function Autocomplete<Option>({
  options,
  value,
  placeholder,
  fullWidth,
  startIcon,
  endIcon,
  onChange,
}: AutocompleteProps<Option>) {
  return (
    <MuiAutocomplete
      options={options}
      renderInput={(params) => (
        <TextField
          {...params}
          slotProps={{
            input: {
              ...params.InputProps,
              startAdornment: startIcon ? (
                <>
                  <InputAdornment position="start">{startIcon}</InputAdornment>
                  {params.InputProps.startAdornment}
                </>
              ) : (
                params.InputProps.startAdornment
              ),
              endAdornment: endIcon ? (
                <>
                  <InputAdornment position="end">{endIcon}</InputAdornment>
                  {params.InputProps.endAdornment}
                </>
              ) : (
                params.InputProps.endAdornment
              ),
            },
          }}
          placeholder={placeholder}
          sx={{
            ".MuiInputAdornment-root": {
              transform: "none",
            },
            ".MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
              marginTop: "16px",
              marginBottom: "16px",
            },
            ".MuiOutlinedInput-notchedOutline": {
              top: 0,
            },
          }}
        />
      )}
      value={value}
      onChange={(_, nextValue) => onChange(nextValue)}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      forcePopupIcon={false}
      fullWidth={fullWidth}
    />
  );
}
